import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

export default function WalletAdjustmentModal({
  open,
  onOpenChange,
  walletData,
  onWalletDataChange,
  onSubmit,
  isLoading
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Adjust Wallet Balance</DialogTitle>
          <DialogDescription>
            Adjusting wallet for: <span className="font-semibold">{walletData.user_name}</span>
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {/* Current Balance */}
          <div className="p-4 bg-slate-100 rounded-xl text-center">
            <p className="text-sm text-slate-500">Current Balance</p>
            <p className="text-2xl font-bold text-slate-900">₱{walletData.current_balance.toLocaleString()}</p>
          </div>

          {/* Amount */}
          <div>
            <Label>Adjustment Amount</Label>
            <Input
              type="number"
              value={walletData.amount}
              onChange={(e) => onWalletDataChange({ ...walletData, amount: e.target.value })}
              placeholder="Enter amount (use negative to deduct)"
              className="mt-1.5"
              data-testid="wallet-amount-input"
            />
            <p className="text-xs text-slate-500 mt-1">
              Use positive number to add, negative to deduct
            </p>
            {walletData.amount && (
              <p className={`text-sm mt-2 ${Number(walletData.amount) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                New balance will be: ₱{(walletData.current_balance + Number(walletData.amount)).toLocaleString()}
              </p>
            )}
          </div>

          {/* Reason */}
          <div>
            <Label>Reason for Adjustment</Label>
            <Input
              value={walletData.reason}
              onChange={(e) => onWalletDataChange({ ...walletData, reason: e.target.value })}
              placeholder="e.g., Refund for cancelled booking"
              className="mt-1.5"
              data-testid="wallet-reason-input"
            />
          </div>

          {/* Admin Password */}
          <div className="p-4 bg-amber-50 border border-amber-200 rounded-xl">
            <Label className="text-amber-800">Admin Password Confirmation</Label>
            <Input
              type="password"
              value={walletData.admin_password}
              onChange={(e) => onWalletDataChange({ ...walletData, admin_password: e.target.value })}
              placeholder="Enter admin password"
              className="mt-1.5"
              data-testid="wallet-password-input"
            />
            <p className="text-xs text-amber-600 mt-1">
              This action will be recorded as "HandyBayani adjustment"
            </p>
          </div>

          <div className="flex gap-2">
            <Button variant="outline" className="flex-1" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button
              className="flex-1 bg-slate-900 hover:bg-slate-800"
              onClick={onSubmit}
              disabled={isLoading || !walletData.amount || !walletData.reason || !walletData.admin_password}
              data-testid="wallet-submit-btn"
            >
              {isLoading ? 'Processing...' : 'Confirm Adjustment'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
